import { IOrder } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IOrder'
import { IHandleStatusText } from '../interfaces/IShelfList'
import { logicHandleStatus, requestRecived } from './logicHandleStatus'

export const handleStatusTextOrderDetail = (
  order?: IOrder
): IHandleStatusText => {
  if (!order) return requestRecived
  const { shippingData, status } = order
  return logicHandleStatus(
    status.toLowerCase(),
    shippingData?.address?.addressType
  )
}
